<input
  type="radio"
  [id]="id"
  [name]="name"
  [class]="inputClasses"
  [checked]="selected()"
  (change)="handleInputChange()"
/>
<label [for]="id" [class]="labelClasses" [title]="labelTitle()">
  <span class="tw-line-clamp-2 tw-break-words" #labelContent>
    <ng-content></ng-content>
  </span>
  <span class="tw-shrink-0" [hidden]="!hasBadge()">
    <ng-content select="[bitBadge]"></ng-content>
  </span>
</label>
